/* Search & jump palette (SHELL1 .pal). */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 120px 16px 16px;
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade 150ms ease-out;
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

.modal {
  width: min(680px, 100%);
  max-height: calc(100vh - 140px);
  overflow: hidden;
  border-radius: 8px;
  background: var(--white);
  box-shadow: var(--shadow-dialog);
  outline: none;
}

.modal[data-entering] {
  animation: palin 180ms ease-out;
}

@keyframes palin {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
}

.dialog {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 140px);
  outline: none;
}

.field {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px 0 18px;
  border-bottom: 1px solid var(--border-card);
  color: var(--brand-navy);
}

.searchField {
  display: flex;
  flex: 1;
  min-width: 0;
}

.input {
  flex: 1;
  min-width: 0;
  height: 56px;
  border: 0;
  background: transparent;
  color: var(--text-body);
  font-size: 17px;
  outline: none;
}

.input::-webkit-search-cancel-button {
  display: none;
}

.escape {
  display: grid;
  place-items: center;
  min-width: 44px;
  min-height: 44px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid var(--border-dashed);
  border-bottom-width: 2px;
  border-radius: var(--radius-sm);
  background: var(--gray-50);
  color: var(--gray-700);
  font: 600 11px/1 var(--font-ui);
}

.results {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 4px 8px 10px;
}

.menu {
  outline: none;
}

.section + .section {
  margin-top: 4px;
}

.groupHeader {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px 4px;
  color: var(--text-muted);
  font-family: var(--font-ui);
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 6px 12px;
  border-radius: 4px;
  color: var(--text-body);
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  outline: none;
}

.item[data-focused],
.item[data-hovered] {
  background: var(--brand-cyan-50);
  box-shadow: inset 3px 0 0 var(--brand-cyan);
}

.itemIcon {
  display: grid;
  flex: none;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: var(--gray-100);
  color: var(--brand-navy);
}

.itemText {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.itemLabel {
  color: var(--text-heading);
  font-weight: var(--fw-semibold);
}

.itemMeta {
  overflow: hidden;
  color: var(--text-secondary);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemKind {
  color: var(--text-secondary);
  font-size: 12px;
  white-space: nowrap;
}

.message {
  margin: 10px 6px 4px;
}

.status {
  padding: 14px;
  color: var(--text-secondary);
  font-size: 14px;
}

.foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 18px;
  padding: 10px 18px;
  border-top: 1px solid var(--border-hairline);
  background: var(--gray-50);
  color: var(--text-secondary);
  font-size: 12px;
}

.hints {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
}

.hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
